import * as tslib_1 from "tslib";
import * as React from 'react';
import { AttachmentCompactView } from 'owa-attachment-compact-view';
import { getListViewDimensions } from 'owa-mail-list-dimensions';
import { format } from 'owa-strings';
import { lazyCreateImageGalleryFromAttachmentViewStateIds } from 'owa-preview-pane-store';
import { lazyCreateImageGalleryFromAttachmentViewStateIds as lazyCreateImageGalleryFromAttachmentViewStateIds2 } from 'owa-sxs-store';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { observer } from 'mobx-react';
import strings from 'owa-strings/owa-mail-strings';
import datapoints from '../datapoints';
import { logVerboseUsage } from 'owa-analytics';
var styles = require('./MailListItemRichPreviewWell.scss');
var classNames = require('classnames/bind').bind(styles);
var mailListItemStyles = require('./MailListItem.scss');
var mailListItemClassNames = require('classnames/bind').bind(mailListItemStyles);
var LV_LEFT_RIGHT_PADDING = 28; // list view left and right padding when in 3 column
var WIDTH_PERSONA_ICON = 48; // width of the persona icon div in 3 column
var SCROLL_BAR_WIDTH = 18; // custom scroll bar width
var WIDTH_ALLOC_FOR_DOC = 136; // 132: width + 4: margin-right
var WIDTH_ALLOC_FOR_IMAGE = 68; // 64: width + 4: margin-right
var WIDTH_OF_PLUS_MORE_DIV = 34; // This needs to be same as width for plus more div in scss file
var MailListItemRichPreviewWell = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemRichPreviewWell, _super);
    function MailListItemRichPreviewWell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.didLogAttachmentDatapoint = false;
        _this.onAfterPreviewAttachment = function () {
            lazyCreateImageGalleryFromAttachmentViewStateIds.importAndExecute(listViewStore.rowAttachmentPreviewWellViews.get(_this.props.rowId).imageViewStateIds);
        };
        _this.createImageGallery = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var createImageGalleryFromAttachmentViewStateIds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, lazyCreateImageGalleryFromAttachmentViewStateIds2.import()];
                    case 1:
                        createImageGalleryFromAttachmentViewStateIds = _a.sent();
                        return [2 /*return*/, createImageGalleryFromAttachmentViewStateIds(listViewStore.rowAttachmentPreviewWellViews.get(this.props.rowId).imageViewStateIds, function (id) { return listViewStore.attachmentViewStates.get(id); })];
                }
            });
        }); };
        return _this;
    }
    MailListItemRichPreviewWell.prototype.renderAttachment = function (attachmentViewStateId, isImage, onlyDocsInView) {
        var attachmentViewState = listViewStore.attachmentViewStates.get(attachmentViewStateId);
        return (React.createElement(AttachmentCompactView, { onPreviewClick: this.props.onPreviewClick, key: attachmentViewState.attachmentId.Id, attachmentViewState: attachmentViewState, isImage: isImage, onAfterPreview: this.onAfterPreviewAttachment, instrumentationContext: this.props.instrumentationContext, createImageGallery: this.createImageGallery, isShortDocView: onlyDocsInView }));
    };
    MailListItemRichPreviewWell.prototype.renderAttachments = function (isImage, attachmentViewStateIds, numberToRender, onlyDocsInView) {
        var renderedAttachments = [];
        for (var i = 0; i < numberToRender; i++) {
            renderedAttachments.push(this.renderAttachment(attachmentViewStateIds[i], isImage, onlyDocsInView));
        }
        return renderedAttachments;
    };
    /**
     * Calculate the number of previews that can be shown and whether to show the plus more div
     * @param numOfDocs - Number of doc present
     * @param numOfImages - Number of images present
     * @param containerWidth - the width available
     * @return The preview view state
     */
    MailListItemRichPreviewWell.prototype.calculatePreviewWellViewState = function (numOfDocs, numOfImages, containerWidth) {
        // start empty
        var previewViewState = {
            shouldShowPlusMore: false,
            numDocToShow: 0,
            numImageToShow: 0,
        };
        var availableContainerWidth = containerWidth;
        // The total width required to accomodate the previews
        var totalRequiredWidth = numOfDocs * WIDTH_ALLOC_FOR_DOC + numOfImages * WIDTH_ALLOC_FOR_IMAGE;
        // We show plus more when we do not have enough space to accommodate the available previews.
        previewViewState.shouldShowPlusMore = totalRequiredWidth > availableContainerWidth;
        // Early return if we are not showing plus more
        if (!previewViewState.shouldShowPlusMore) {
            return {
                shouldShowPlusMore: false,
                numDocToShow: numOfDocs,
                numImageToShow: numOfImages,
            };
        }
        // If we show plus more then we have to allocate the space for it and hence the container width available should be reduced by the
        // space taken by the plus more div
        availableContainerWidth -= WIDTH_OF_PLUS_MORE_DIV;
        // calculate number of documents to show
        var numOfDocsThatCanFit = Math.floor(availableContainerWidth / WIDTH_ALLOC_FOR_DOC);
        previewViewState.numDocToShow = Math.min(numOfDocs, numOfDocsThatCanFit);
        availableContainerWidth =
            availableContainerWidth - previewViewState.numDocToShow * WIDTH_ALLOC_FOR_DOC;
        // calculate number of images to show
        var numOfImagesThatCanFit = Math.floor(availableContainerWidth / WIDTH_ALLOC_FOR_IMAGE);
        previewViewState.numImageToShow = Math.min(numOfImages, numOfImagesThatCanFit);
        return previewViewState;
    };
    /**
     * Calculates the available container width
     */
    MailListItemRichPreviewWell.prototype.getContainerWidth = function () {
        var containerWidth = 0;
        if (this.props.isWideView) {
            containerWidth = 500; // VSO-13179 - SLV, how to get container width and pass it before render.
        }
        else {
            var listViewWidth = getListViewDimensions().listViewWidth;
            containerWidth =
                listViewWidth - LV_LEFT_RIGHT_PADDING - WIDTH_PERSONA_ICON - SCROLL_BAR_WIDTH;
        }
        return containerWidth;
    };
    MailListItemRichPreviewWell.prototype.renderPreviewWell = function (attachmentPreviewWellViewState) {
        var nonEmptyPreviewContainerClasses = classNames(styles.previewWell, [
            'disableTextSelection',
            styles.oneRowAttachmentPreviews,
        ]);
        var numOfDocs = attachmentPreviewWellViewState.documentViewStateIds.length;
        var numOfImages = attachmentPreviewWellViewState.imageViewStateIds.length;
        var totalNumberOfAttachmentPreviews = numOfDocs + numOfImages;
        // Calculate the number of previews that can be shown and whether to show the plus more div
        var previewViewState = this.calculatePreviewWellViewState(numOfDocs, numOfImages, this.getContainerWidth());
        var onlyDocsInView = previewViewState.numImageToShow === 0;
        if (onlyDocsInView) {
            nonEmptyPreviewContainerClasses = classNames(styles.previewWellInShortDocView, nonEmptyPreviewContainerClasses);
        }
        if (!this.didLogAttachmentDatapoint) {
            logVerboseUsage(datapoints.MailListItemAttachmentPreviewDatapoint.datapoint.name, datapoints.MailListItemAttachmentPreviewDatapoint.datapoint.customData(totalNumberOfAttachmentPreviews, numOfDocs, numOfImages, previewViewState));
            this.didLogAttachmentDatapoint = true;
        }
        return (React.createElement("div", { className: nonEmptyPreviewContainerClasses },
            this.renderAttachments(false /* isImage */, attachmentPreviewWellViewState.documentViewStateIds, previewViewState.numDocToShow, onlyDocsInView),
            this.renderAttachments(true /* isImage */, attachmentPreviewWellViewState.imageViewStateIds, previewViewState.numImageToShow, onlyDocsInView),
            previewViewState.shouldShowPlusMore && (React.createElement("div", { className: onlyDocsInView
                    ? styles.plusMoreNumberInShortDocView
                    : styles.plusMoreNumber }, format(strings.plusMoreInlinePreviews, totalNumberOfAttachmentPreviews -
                previewViewState.numDocToShow -
                previewViewState.numImageToShow)))));
    };
    MailListItemRichPreviewWell.prototype.render = function () {
        var attachmentPreviewWellViewState = listViewStore.rowAttachmentPreviewWellViews.get(this.props.rowId);
        var containerDivClasses = mailListItemClassNames('disableTextSelection', this.props.isWideView
            ? mailListItemStyles.inlinePreviewsSingleLine
            : mailListItemStyles.inlinePreviewsThreeColumn);
        var emptyInlinePreviews = classNames(styles.previewWell, styles.oneRowAttachmentPreviews);
        return (React.createElement("div", { className: containerDivClasses }, attachmentPreviewWellViewState ? (this.renderPreviewWell(attachmentPreviewWellViewState)) : (React.createElement("div", { className: emptyInlinePreviews },
            React.createElement("div", { className: styles.placeholderInEmptyView })))));
    };
    MailListItemRichPreviewWell = tslib_1.__decorate([
        observer
    ], MailListItemRichPreviewWell);
    return MailListItemRichPreviewWell;
}(React.Component));
export default MailListItemRichPreviewWell;
//# sourceMappingURL=MailListItemRichPreviewWell.js.map